var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSeo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.4989 9.28675C18.3727 13.1164 19.672 18.5134 14.0585 18.3996C11.8131 18.526 9.55503 18.5766 7.297 18.526C3.94148 18.4881 -0.170925 18.6271 0.00568097 14.0897C0.00568097 10.7908 0.00568097 7.49197 0.00568097 4.19313C-0.107852 2.14557 1.49422 0.274963 3.56304 0.199127C6.04814 0.0348171 8.54585 -0.0410184 11.031 0.0221778C19.3062 -0.18005 18.5493 2.19613 18.4989 9.28675Z",
    fill: "#FEBDB6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M14 4.00069C13.9725 4.00023 13.9449 4 13.9173 4C11.2016 4 9 6.23858 9 9C9 11.7614 11.2016 14 13.9173 14C13.9449 14 13.9725 13.9998 14 13.9993L14 4.00069Z",
    fill: "url(#paint0_linear_796_4302)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    d: "M4 13.9993C4.0275 13.9998 4.05506 14 4.08266 14C6.79842 14 9 11.7614 9 9C9 6.23858 6.79842 4 4.08266 4C4.05507 4 4.0275 4.00023 4 4.00069L4 13.9993Z",
    fill: "url(#paint1_linear_796_4302)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_3",
    d: "M4.00069 4C4.00023 4.0275 4 4.05505 4 4.08266C4 6.79843 6.23858 9 9 9C11.7614 9 14 6.79843 14 4.08266C14 4.05505 13.9998 4.0275 13.9993 4L4.00069 4Z",
    fill: "url(#paint2_linear_796_4302)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_4",
    d: "M13.9993 14C13.9998 13.9725 14 13.9449 14 13.9173C14 11.2016 11.7614 9 9 9C6.23858 9 4 11.2016 4 13.9173C4 13.9449 4.00023 13.9725 4.00069 14L13.9993 14Z",
    fill: "url(#paint3_linear_796_4302)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_796_4302",
    x1: 9,
    y1: 9,
    x2: 18.8347,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515547,
    stopColor: "#CEFFEB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_796_4302",
    x1: 9,
    y1: 9,
    x2: -0.834687,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.450547,
    stopColor: "#CEFFEB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_796_4302",
    x1: 8.99991,
    y1: 9,
    x2: 8.99991,
    y2: -0.834686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500547,
    stopColor: "#CEFFEB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_796_4302",
    x1: 9.00009,
    y1: 9,
    x2: 9.00009,
    y2: 18.8347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520547,
    stopColor: "#CEFFEB",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSeo);
export default __webpack_public_path__ + "static/media/IconSeo.8246e17f92760cfc56edd0fd49ee1674.svg";
export { ForwardRef as ReactComponent };